import { useCallback, useEffect, useState } from 'react';

// Read by support-widget.global.scss to lift the launcher above a sticky CTA bar
export const STICKY_CTA_HEIGHT_VAR = '--sticky-cta-height';

// Callback ref: the bar can mount late (after an early return) or detach before unmount
export const useStickyCtaOffset = (rootClass: string): ((node: HTMLElement | null) => void) => {
  const [bar, setBar] = useState<HTMLElement>();

  useEffect(() => {
    if (!bar || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    const root = document.documentElement;
    // Measured, not hardcoded: CTA variants render one or two buttons
    const syncHeight = () => root.style.setProperty(STICKY_CTA_HEIGHT_VAR, `${bar.offsetHeight}px`);
    const observer = new ResizeObserver(syncHeight);

    syncHeight();
    observer.observe(bar);
    root.classList.add(rootClass);

    return () => {
      observer.disconnect();
      root.classList.remove(rootClass);
      root.style.removeProperty(STICKY_CTA_HEIGHT_VAR);
    };
  }, [bar, rootClass]);

  return useCallback((node: HTMLElement | null) => setBar(node ?? undefined), []);
};
